import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCurrentPage,
  requestsSelector,
  setHideSideBar,
  setRequestData,
  setSubmitButtonTitle,
  updateRequestPages,
} from '../../../redux/slicers/requestSlicer';
import styles from './Parts.module.scss';
import { BigButton } from '../../../common';
import cx from 'classnames';
import ImageSlider from './ImageSlider';
import { setCurrentRequestSubPageId } from '../../../redux/slicers/requestSlicer';
import PartsDetail from './PartsDetail';
import icons from '../../../assets';
import {
  apiDeleteRequestParts,
  apiUpdateRequestPart,
  apiUploadRequestParts,
} from '../../../helpers/api';

function PartsZoom() {
  const dispatch = useDispatch();
  const _requestSelector = useSelector(requestsSelector);
  const currentPage = useSelector(getCurrentPage);
  const [parts, setParts] = useState(_requestSelector?.requestData?.parts || []);
  const [scale, setScale] = useState(1);
  const [loading, setLoading] = useState(false);
  const { PlusIcon } = icons;

  const handleCloseClick = () => {
    dispatch(setCurrentRequestSubPageId(null));
  };
  const handleSaveClick = async () => {
    setLoading(true);
    dispatch(
      updateRequestPages({ ...currentPage, data: { ..._requestSelector.requestData, parts } })
    );

    const unselectedImages = _requestSelector?.requestData?.parts
      .filter(
        (_item) =>
          !_requestSelector.requestData.images
            ?.map((item) => item.id)
            .includes(_item.currentImageId)
      )
      ?.map((_item) => _item.currentImageId);

    const formData = new FormData();
    formData.append('delete_notes', true);

    unselectedImages
      .filter((_item, i, ar) => ar.indexOf(_item) === i)
      .map(async (_image) => await apiDeleteRequestParts(_image, formData));

    if (!parts?.length) {
      dispatch(setCurrentRequestSubPageId(null));
      return;
    }

    const newParts = parts?.filter((_item) => !_item.actual_id);
    const oldParts = parts?.filter((_item) => _item.actual_id);

    oldParts.map(
      async (_item) =>
        await apiUpdateRequestPart(
          _item.actual_id,
          JSON.stringify({
            name: _item.name,
            json_data: _item,
            note: _item.note,
          })
        )
    );

    if (!newParts?.length) {
      dispatch(setCurrentRequestSubPageId(null));
      return;
    }

    const payload = newParts.map((_item) => {
      return {
        three_d_model_request: _requestSelector.currentRequestId,
        requested_model_file: _item?.currentImageId,
        name: _item.value,
        sequence_number: _item.id,
        note: _item?.note || '',
        json_data: _item,
      };
    });

    const response = await apiUploadRequestParts(JSON.stringify(payload));

    setLoading(false);

    if (response.status) {
      dispatch(setCurrentRequestSubPageId(null));
      dispatch(setRequestData(response?.data));
    }
  };

  const onZoomClick = () => {
    if (scale < 2) {
      setScale(scale + 0.25);
    }
  };

  const onZoomOutClick = () => {
    if (scale > 0.5) {
      setScale(scale - 0.25);
    }
  };

  useEffect(() => {
    dispatch(setHideSideBar(true));
    return () => dispatch(setHideSideBar(false));
  }, []);

  const getFilteredParts = () => {
    const _parts = parts.filter((_item) =>
      _requestSelector.requestData.images?.map((item) => item.id).includes(_item.currentImageId)
    );

    return _parts.map((_item, index) => ({ ..._item, id: index + 1 }));
  };

  return (
    <div className={styles.partsZoomWrapper}>
      {/* <div className={styles.zoomWrapper}>
        <span className={styles.zoomOutButtons} onClick={onZoomOutClick}>
          <span>-</span>
        </span>
        <span style={{ width: '50px' }}>%{scale * 100}</span>
        <span className={styles.zoomButtons} onClick={onZoomClick}>
          <PlusIcon />
        </span>
      </div> */}
      <div className={styles.partsZoomSubWrapper}>
        <div className={cx('d-flex p-3 h-100 gap-3', styles.flexWrapper)}>
          <div className={styles.image}>
            <ImageSlider
              images={_requestSelector.requestData.images || []}
              parts={getFilteredParts()}
              setParts={setParts}
              scale={scale}
              setScale={setScale}
            />
          </div>
          <div className={styles.parts}>
            <PartsDetail parts={getFilteredParts()} setParts={setParts} />
          </div>
        </div>

        <div className={styles.footer}>
          <BigButton className={styles.close} onClick={handleCloseClick}>
            Close
          </BigButton>
          <BigButton className={styles.save} onClick={handleSaveClick} isLoading={loading}>
            Save and continue
          </BigButton>
        </div>
      </div>
    </div>
  );
}

export default PartsZoom;
